"use client";

import React from "react";
import FunnelContainer from "@/components/FunnelContainer"; // Import the new FunnelContainer

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-start p-4 pt-8">
      <FunnelContainer />
    </div>
  );
};

export default Index;
